import { ReactNode } from 'react';
import { Navigate, useLocation, useParams, useSearchParams } from 'react-router-dom';

import { v2Path } from '../model/urls';

interface Props {
  /** Which v2 screen the old route maps to. */
  target: 'form' | 'edit-template' | 'new-template';
  children: ReactNode;
}

/**
 * Wraps the old `?type=` routes (transfer-page, templates-page/edit-template|new-template).
 * When the type already lives in transfer-v2 — via the sidebar link, a bookmark or v1's own tab
 * switch — the user is sent to the v2 URL with the navigation state kept; otherwise the old page
 * renders as before. The old page itself is not changed.
 */
const V1Redirect = ({ target, children }: Props) => {
  const { lang } = useParams();
  const { state } = useLocation();
  const [searchParams] = useSearchParams();
  const path = v2Path(searchParams.get('type'));

  if (!path) {
    return <>{children}</>;
  }

  const suffix = target === 'form' ? '' : `/${target}`;

  return <Navigate to={`/${lang}/${path}${suffix}`} state={state} replace />;
};

export default V1Redirect;
